import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab3b9ec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "abs newMemberBlock"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "abs newMemberTitle flex-cen-ter" }
const _hoisted_4 = {
  class: "abs newMemberTag flex-cen-ter",
  style: {"text-align":"right"}
}
const _hoisted_5 = { class: "vip-card-icon flex-col-ter ref" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "vip-card-name" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "vip-card-info" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "vip-card-price" }
const _hoisted_12 = { class: "vip-card-now-price flex-cen-aiend" }
const _hoisted_13 = { class: "trialPrice" }
const _hoisted_14 = { class: "trialUnit" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "price" }
const _hoisted_17 = { class: "unit" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "price" }
const _hoisted_20 = { class: "unit" }
const _hoisted_21 = { class: "vip-card-old-price" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "price" }
const _hoisted_24 = { class: "unit" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "price" }
const _hoisted_28 = { class: "unit" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "price" }
const _hoisted_31 = { class: "unit" }
const _hoisted_32 = {
  key: 0,
  class: "lastNumTag flex-cen-ter abs"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lastNumTriangle abs" }, null, -1))

import { t } from '@/plugins/i18n'
import { ref, toRef, computed } from 'vue'
import { getCurrentMonetaryUnit, formatCountryMoney, formatMoneyDirection, getActivePriceByStation } from '@/util/useYan'
import { useStore } from 'vuex'
import { Site } from '@/common/const'
import { isJA, useSite, isEN } from '@/store/index'
import { formatMoney } from '@/plugins/utils'

export default /*#__PURE__*/_defineComponent({
  props: {
  vipInfo: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
  emits: ['open'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()
const userInfo = computed(() => {
  return store.getters.user
})


const currentMonetaryUnit = getCurrentMonetaryUnit()

const vipTemplateIcon = [
  '',
  require('@/assets/image/vipImg/badge_economy.png'),
  require('@/assets/image/vipImg/badge_standard.png'),
  require('@/assets/image/vipImg/badge_business.png'),
  require('@/assets/image/vipImg/badge_first.png')
]
const vipCrownList = [
  '',
  require('@/assets/image/vipImg/icon_vip_economy.png'),
  require('@/assets/image/vipImg/icon_vip_standard.png'),
  require('@/assets/image/vipImg/icon_vip_bussiness.png'),
  require('@/assets/image/vipImg/icon_vip_first.png')
]
const newMemberFlag = props.vipInfo.priceItemList.some((v: any) => v.trialFlag)
const newMemberFlagIcon = require('@/assets/image/icon/member/newmember_tag_trapezoid@2x.png')
const newMember = newMemberFlag && props.vipInfo.priceItemList.filter((v: any) => v.trialFlag)[0]
const newMemberTag = computed(() => {
  if (newMember.trialDiscount === 0) {
    return t('新客{A}円', { A: getActivePriceByStation() })
  }
  if (newMember.trialDiscount === -2) {
    return t('新客{A}円', { A: 0 })
  }
  return `${t('新客{x}折', { x: String((10 - newMember.trialDiscount) * 10) })}`
})

const open = () => {
  emit('open')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vip-card", 'vip-card-' + _unref(useSite)()]),
    onClick: open
  }, [
    (_unref(newMemberFlag))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(newMemberFlagIcon),
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, "- " + _toDisplayString(_unref(t)('新限量')) + "-", 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(newMemberTag)), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass('vip-card-line vip-card-line' + __props.vipInfo.templateLevel)
      }, null, 2),
      _createElementVNode("img", {
        src: vipTemplateIcon[__props.vipInfo.templateLevel],
        alt: ""
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString(__props.vipInfo.priceName), 1),
    _createElementVNode("div", {
      class: "vip-card-tip",
      innerHTML: __props.vipInfo.templateDesc
    }, null, 8, _hoisted_8),
    _createElementVNode("div", {
      class: _normalizeClass('vip-card-text vip-card-text' + __props.vipInfo.templateLevel)
    }, _toDisplayString(__props.vipInfo.priceName) + " " + _toDisplayString(_unref(t)('サービス')), 3),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.vipInfo.tagList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "vip-card-info-item",
          key: index
        }, [
          _createElementVNode("img", {
            src: vipCrownList[__props.vipInfo.templateLevel],
            alt: ""
          }, null, 8, _hoisted_10),
          _createElementVNode("span", null, _toDisplayString(item.tagName), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_unref(newMemberFlag))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formatMoneyDirection)(_unref(newMember).trialPrice, true)), 1),
              _createElementVNode("span", _hoisted_14, "/" + _toDisplayString(_unref(t)('首月')), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(formatMoney)(__props.vipInfo.discountActualPrice)), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('{currency}/月', { currency: _unref(currentMonetaryUnit) })), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatMoneyDirection)(__props.vipInfo.discountActualPrice)), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('{currency}/月', { currency: "" })), 1)
                  ]))
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_21, [
        (!_unref(newMemberFlag) && __props.vipInfo.discountPrice)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(formatMoney)(__props.vipInfo.discountPrice)), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('{currency}/月', { currency: _unref(currentMonetaryUnit) })), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25))
            ], 64))
          : _createCommentVNode("", true),
        (_unref(newMemberFlag) && __props.vipInfo.discountActualPrice)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(formatMoney)(__props.vipInfo.discountActualPrice)), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('{currency}/月', { currency: _unref(currentMonetaryUnit) })), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(formatMoneyDirection)(__props.vipInfo.discountActualPrice)), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)('{currency}/月', { currency: '' })), 1)
                  ]))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass('vip-card-btn vip-card-btn' + __props.vipInfo.templateLevel)
    }, [
      _createTextVNode(_toDisplayString(_unref(userInfo).membership?.membershipTemplateId ===
      __props.vipInfo.membershipTemplateId ? _unref(t)('去续费') : _unref(t)('去开通')), 1),
      (_unref(newMemberFlag) && _unref(newMember).limitedQuantityStatus && !_unref(isEN)())
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createTextVNode(_toDisplayString(_unref(t)('名额仅剩X名').replace('X', _unref(newMember).lastQuantity)) + " ", 1),
            _hoisted_33
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})